import React, { Component } from 'react';
import { WidgetHelper } from '../WidgetHelper';
import { FondsRebondFormWidget } from './FondsRebondFormWidget';

interface IFondsRebondPageWidgetProps {
    dictIdentificationCodeCuratorLabel: string;
    dictIdentificationCodeOutplacementLabel: string;
    dictDenominationCuratorLabel: string;
    dictDenominationOutplacementLabel: string;
    dictFilesLabel: string;
    dictNameCuratorLabel: string;
    dictNameOutplacementLabel: string;
    dictSurnameCuratorLabel: string;
    dictSurnameOutplacementLabel: string;
    dictNameWorkerLabel: string;
    dictSurnameWorkerLabel: string;
    dictErrorSubmit: string;
    dictOutplacementTitle: string;
    dictCuratorTitle: string;
    dictSubmitLabel: string;
    dictUploadLabel: string;
    dictBackLabel: string;
    dictTitle: string;
    dictFailLabel: string;
    dictSuccessText: string;
    dictSuccessContact1: string;
    dictSuccessContact2: string;
    dictSuccessMail: string;
    dictSuccessPhone: string;
    dictSuccessSignature1: string;
    dictSuccessSignature2: string;
    dictCurator: string;
    dictOutplacement: string;
    dictRetryLabel: string;
    dictNoTitle: string;
    dictGdprLabel: string;
    dictGdprLink: string;
    dictGdprUrl: string;
    dictFilesWorkersListLabel: string;
    dictFilesOtherLabel: string;
    dictFilesAttestationLabel: string;
    dictFilesAccordLabel: string;
    dictFilesPositiveProofLabel: string;
    dictFilesPlanLabel: string;
    dictNoneLabel: string;
    dictErrorFileFormat: string;
    dictErrorFileSize: string;
    dictIdentificationCodeError: string;
}

interface IFondsRebondPageWidgetState {
    buttonClicked: number;
}

export class FondsRebondPageWidget extends Component<
    IFondsRebondPageWidgetProps,
    IFondsRebondPageWidgetState
> {
    constructor(props: IFondsRebondPageWidgetProps) {
        super(props);
        this.state = {
            buttonClicked: null as any,
        };
    }

    handleCurator = (): void => {
        this.setState({ buttonClicked: 1 });
    };

    handleOutplacement = (): void => {
        this.setState({ buttonClicked: 2 });
    };

    handleBack = (): void => {
        this.setState({ buttonClicked: null as any });
    };

    renderButtonClicked() {
        return (
            <div>
                <div className="container-max banner--full-width__title w-100">
                    <div className="row">
                        <div className="offset-3 col-6">
                            <div className="row">
                                <div className="col-12">
                                    <h1 className="pb-0">
                                        {this.props.dictTitle}
                                    </h1>
                                </div>
                                <div className="col-12">
                                    {this.state.buttonClicked === 2 && (
                                        <h1 className="font-weight-normal pt-0">
                                            {this.props.dictOutplacementTitle}
                                        </h1>
                                    )}
                                    {this.state.buttonClicked === 1 && (
                                        <h1 className="font-weight-normal pt-0">
                                            {this.props.dictCuratorTitle}
                                        </h1>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-2 pt-5">
                            <button onClick={this.handleBack}>
                                <i className="icon-angleLeft"></i>
                                {this.props.dictBackLabel}
                            </button>
                        </div>
                    </div>
                    <div className="row">
                        <div className="offset-2 col-8 text-center">
                            <FondsRebondFormWidget
                                type={this.state.buttonClicked}
                                dictIdentificationCodeCuratorLabel={
                                    this.props
                                        .dictIdentificationCodeCuratorLabel
                                }
                                dictIdentificationCodeOutplacementLabel={
                                    this.props
                                        .dictIdentificationCodeOutplacementLabel
                                }
                                dictDenominationCuratorLabel={
                                    this.props.dictDenominationCuratorLabel
                                }
                                dictDenominationOutplacementLabel={
                                    this.props.dictDenominationOutplacementLabel
                                }
                                dictFilesLabel={this.props.dictFilesLabel}
                                dictNameCuratorLabel={
                                    this.props.dictNameCuratorLabel
                                }
                                dictNameOutplacementLabel={
                                    this.props.dictNameOutplacementLabel
                                }
                                dictSurnameCuratorLabel={
                                    this.props.dictSurnameCuratorLabel
                                }
                                dictSurnameOutplacementLabel={
                                    this.props.dictSurnameOutplacementLabel
                                }
                                dictNameWorkerLabel={
                                    this.props.dictNameWorkerLabel
                                }
                                dictSurnameWorkerLabel={
                                    this.props.dictSurnameWorkerLabel
                                }
                                dictErrorSubmit={this.props.dictErrorSubmit}
                                dictSubmitLabel={this.props.dictSubmitLabel}
                                dictUploadLabel={this.props.dictUploadLabel}
                                dictSuccessText={this.props.dictSuccessText}
                                dictSuccessContact1={
                                    this.props.dictSuccessContact1
                                }
                                dictSuccessContact2={
                                    this.props.dictSuccessContact2
                                }
                                dictSuccessMail={this.props.dictSuccessMail}
                                dictSuccessPhone={this.props.dictSuccessPhone}
                                dictSuccessSignature1={
                                    this.props.dictSuccessSignature1
                                }
                                dictSuccessSignature2={
                                    this.props.dictSuccessSignature2
                                }
                                dictFailLabel={this.props.dictFailLabel}
                                dictRetryLabel={this.props.dictRetryLabel}
                                backFunc={this.handleBack}
                                dictGdprLabel={this.props.dictGdprLabel}
                                dictGdprLink={this.props.dictGdprLink}
                                dictGdprUrl={this.props.dictGdprUrl}
                                dictFilesWorkersListLabel={
                                    this.props.dictFilesWorkersListLabel
                                }
                                dictFilesOtherLabel={
                                    this.props.dictFilesOtherLabel
                                }
                                dictFilesAttestationLabel={
                                    this.props.dictFilesAttestationLabel
                                }
                                dictFilesAccordLabel={
                                    this.props.dictFilesAccordLabel
                                }
                                dictFilesPositiveProofLabel={
                                    this.props.dictFilesPositiveProofLabel
                                }
                                dictFilesPlanLabel={
                                    this.props.dictFilesPlanLabel
                                }
                                dictNoneLabel={this.props.dictNoneLabel}
                                dictErrorFileFormat={
                                    this.props.dictErrorFileFormat
                                }
                                dictErrorFileSize={this.props.dictErrorFileSize}
                                dictIdentificationCodeError={
                                    this.props.dictIdentificationCodeError
                                }
                            ></FondsRebondFormWidget>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (this.state.buttonClicked) {
            return this.renderButtonClicked();
        } else {
            return (
                <div>
                    <div className="container-max banner--full-width__title w-100">
                        <div className="row">
                            <div className="offset-3 col-6">
                                <div className="col-12">
                                    <h1 className="pb-0">
                                        {this.props.dictTitle}
                                    </h1>
                                </div>
                                <div className="col-12">
                                    <h1 className="font-weight-normal pt-0">
                                        {this.props.dictNoTitle}
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row pt-5">
                            <div className="offset-2 col-8 text-center">
                                <button
                                    className="mr-2"
                                    onClick={this.handleCurator}
                                >
                                    {this.props.dictCurator}
                                </button>
                                <button
                                    className="ml-2"
                                    onClick={this.handleOutplacement}
                                >
                                    {this.props.dictOutplacement}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

WidgetHelper.register(FondsRebondPageWidget, 'fonds-rebond-page-widget');
